import { c as mobileTypography, e as mobileLink } from '../base/typography-j1qfCKl5.js';
import { b as mobileSpacingValues, m as mobileSpacing } from '../base/spacing-zNVNrnl_.js';
import { m as mobileButton } from '../component/button-DzuTwMo0.js';
import { m as mobileDividerStyles } from '../component/divider-C7Pe4BVz.js';
import { m as mobileDropdownStyles } from '../component/dropdown-Bu5wlgg6.js';
import { m as mobileHelptipStyles } from '../component/helptip-BP8axqu3.js';
import { m as mobileInputStyles } from '../component/input-bqcyBnEK.js';
import { m as mobileTagStyles } from '../component/tag-BItIQvRd.js';
import { m as mobileTouchLink } from '../component/touchLink-CzpG8W70.js';
import { m as mobileTree } from '../component/tree-BeeBH0oq.js';
import { m as mobileRadioStyles } from '../component/radio-DdysEhyl.js';
import { m as mobileSearchInputStyles } from '../component/searchInput-DQA9YiST.js';
import { m as mobileAlertStyles } from '../component/alert-YJFz3xiV.js';
import { m as mobileCheckboxStyles } from '../component/checkbox-9mCPwUIz.js';
import { m as mobileTabNavigationStyles } from '../component/tabNavigation-CjQBNNXm.js';
import { m as mobilePagination } from '../component/pagination-Bf5FM4AC.js';
import { m as mobilePill$1 } from '../component/pillLegacy-DGmoml8T.js';
import { m as mobilePill } from '../component/pill-Dpiov0cX.js';
import { m as mobileTableStyles } from '../component/table-zKa7sg3k.js';
import { m as mobileDatepickerStyles } from '../component/datepicker-D-v9RfGZ.js';
import { m as mobileSwitchStyles } from '../component/switch-ClnqNU3i.js';

const mobileMediaQuery = '(orientation: portrait) and (max-width: 575.98px) and (pointer: coarse), (orientation: landscape) and (max-height: 575.98px) and (pointer: coarse)';
const notMobileMediaQuery = 'all and (orientation: portrait) and (min-width: 576px), all and (orientation: landscape) and (min-height: 576px), all and (pointer: fine)';
const theme = {
  mobile: {
    mediaQuery: mobileMediaQuery,
    inverseMediaQuery: notMobileMediaQuery,
    spacing: mobileSpacing,
    spacingValues: mobileSpacingValues,
    link: mobileLink
  },
  globals: {
    mobile: {
      link: mobileLink // DEPRECATE
    }
  },
  typography: mobileTypography,
  button: mobileButton,
  divider: mobileDividerStyles,
  dropdown: mobileDropdownStyles,
  tag: mobileTagStyles,
  form: {
    input: mobileInputStyles,
    radio: mobileRadioStyles,
    search: mobileSearchInputStyles,
    checkbox: mobileCheckboxStyles
  },
  message: mobileAlertStyles,
  touchLink: mobileTouchLink,
  tree: mobileTree,
  navigation: {
    tabs: mobileTabNavigationStyles
  },
  switch: mobileSwitchStyles,
  pagination: mobilePagination,
  pillLegacy: mobilePill$1,
  pillv2Beta: mobilePill,
  // adding in for TropicalUI support, which references this theme value
  pill: mobilePill,
  table: mobileTableStyles,
  datepicker: mobileDatepickerStyles,
  helptip: mobileHelptipStyles
};

export { theme as t };
//# sourceMappingURL=mobile-fusTO8VO.js.map
